module.exports = __webpack_public_path__ + "img/xinwen2.b7870b71.png";